/**
 * Open the cart drawer after an add-to-cart.
 *
 * The theme adds via ajax (`use_ajax_atc: true`) and updates the drawer contents, but it
 * never actually opens it - verified identical on the live theme, so this is long-standing
 * behaviour rather than a regression. The shopper gets no confirmation that anything
 * happened, which is a poor signal on a store where the cart is the leakiest funnel step.
 *
 * Opens via the drawer's own `open()` method. The `openCartDrawer` pub/sub event does NOT
 * work - emitting it leaves the drawer closed - so do not use it here.
 */
(function () {
  if (window.__mCartAutoOpen) return;
  window.__mCartAutoOpen = true;

  // Only open in response to a real add-to-cart, never on quantity edits or removals.
  let pendingAdd = false;

  document.addEventListener(
    'click',
    (event) => {
      if (event.target.closest('.m-add-to-cart, [data-pau-add]')) pendingAdd = true;
    },
    true
  );

  function openDrawer() {
    if (!pendingAdd) return;
    pendingAdd = false;

    // The cart page has no drawer to speak of - leave it alone.
    if (document.body.classList.contains('template-cart')) return;

    const drawer = document.querySelector('m-cart-drawer');
    if (!drawer || typeof drawer.open !== 'function') return;
    if (drawer.classList.contains('m-cart-drawer--active')) return;

    drawer.open();
  }

  function subscribe() {
    if (window.MinimogEvents && window.MinimogTheme && MinimogTheme.pubSubEvents) {
      MinimogEvents.subscribe(MinimogTheme.pubSubEvents.cartUpdate, () => {
        // Let the theme finish re-rendering the drawer contents first.
        window.setTimeout(openDrawer, 80);
      });
      return true;
    }
    return false;
  }

  if (!subscribe()) {
    document.addEventListener('DOMContentLoaded', subscribe);
  }
})();
